// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__3e6NK","switchToggle":"Switch_switchToggle__36_3x"};